type WorkspaceUserStatus = {
  id?: string;
  _id?: string;
  status?: string;
  deletedAt?: unknown;
};

const inactiveStatuses = new Set([
  'deactivated',
  'deleted',
  'inactive',
  'invitation_sent',
  'invited',
  'pending',
  'suspended',
]);

const invitationStatuses = new Set(['invitation_sent', 'invited', 'pending']);

export const isPendingWorkspaceInvitation = (user: WorkspaceUserStatus) =>
  invitationStatuses.has(
    String(user?.status || '')
      .trim()
      .toLowerCase(),
  );

export const isActiveWorkspaceUser = (user: WorkspaceUserStatus): boolean =>
  Boolean(user && (user.id || user._id) && !user.deletedAt) &&
  !inactiveStatuses.has(
    String(user.status || '')
      .trim()
      .toLowerCase(),
  );
